var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLandingLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 140,
    viewBox: "0 0 375 140",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.625 72.0908C485.625 72.0908 485.812 71.7546 486 71.7546C448.486 48.7248 394.653 27.0398 336.882 25.3588C279.11 22.5011 220.776 39.1431 171.069 61.5005C121.926 83.6898 81.4107 111.763 48.7735 126.387C15.9487 141.685 -13.1247 143.702 -40.1348 127.564C-39.9473 127.732 -39.7597 128.068 -39.3846 128.405C-12.3745 144.878 16.699 143.029 49.3362 127.732C81.7859 113.107 122.114 85.0346 171.257 62.6772C220.963 40.1517 279.11 23.5097 336.882 26.1993C394.466 27.7122 448.298 49.2291 485.812 72.0908H485.625Z",
    fill: "#149C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-44.6635 55.5632C-44.6635 55.5632 -44.8309 55.3189 -44.9984 55.1967C-4.64478 25.6263 47.9321 5.34257 102.351 1.18806C157.104 -3.6996 211.523 7.05325 260.584 23.1825C308.807 39.1896 350.835 61.3062 383.821 75.9692C417.31 91.1209 444.77 98.4524 471.059 95.3976C470.891 95.5198 470.724 95.7642 470.556 95.8864C444.268 99.0634 416.807 91.8541 383.486 76.8245C350.668 62.1616 308.64 40.0449 260.584 23.9157C211.691 7.78639 157.272 -2.96645 102.518 1.79902C47.9321 5.95352 -4.47733 25.9929 -44.6635 55.4411V55.5632Z",
    fill: "#149C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLandingLines);
export default __webpack_public_path__ + "static/media/MobileLandingLines.4b691678bf97301c98b45daef4274663.svg";
export { ForwardRef as ReactComponent };